"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const qs_1 = __importDefault(require("qs"));
const lodash_1 = __importDefault(require("lodash"));
const API = {
    APIKeyREST: (serviceId) => `/blockpass_console/v1/services/${serviceId}/apiKeys`,
};
class APIKey {
    constructor(httpClient, config) {
        this._httpClient = httpClient;
        this._baseURL = config.baseURL;
    }
    /**
     * https://qa-console.blockpass.org/blockpass_console/v1/services/62467636340a771c11c6607f/apiKeys?page=0&limit=10&query=
     * method: GET
     * res: {"status":"success","data":{"list":[{"_id":"6360f5d6a73c4179172679f6","description":"Dev API KEY","scopes":["includeRawData","archiveDataAfterExtract:10"],"active":true,"name":"148...9e0","updatedAt":"2022-11-01T10:32:54.331Z"},{"_id":"6360f5fca73c417917267a63","description":"Dev API KEY return only","scopes":["includeRawData","textDataOnly","archiveDataAfterExtract:10"],"active":true,"name":"782...fd1","updatedAt":"2022-11-01T10:38:04.923Z"}],"total":2}}
     */
    async getListAPIKey(serviceId, page = 10, limit = 10) {
        const query = {
            page,
            limit,
        };
        const url = `${API.APIKeyREST(serviceId)}?${qs_1.default.stringify(query)}`;
        const res = await this._httpClient.get(url, { baseURL: this._baseURL });
        const data = {
            result: null,
            paging: {
                page,
                limit,
                total: page,
            },
            entities: {},
        };
        if (!res.data || !res.data.data) {
            return data;
        }
        const resBody = res.data.data;
        data.result = lodash_1.default.map(resBody.list, '_id');
        data.paging.total = resBody.total;
        data.entities = { apiKeys: lodash_1.default.keyBy(resBody.list, '_id') };
        return data;
    }
    /**
     * https://qa-console.blockpass.org/blockpass_console/v1/services/62467636340a771c11c6607f/apiKeys
     * method: POST
     * payload:
     * - {"description":"Dev API KEY return only","scopes":[]}
     * - {"description":"Dev API KEY","scopes":["includeRawData","archiveDataAfterExtract:10"]}
     * - {"description":"Auto archive","scopes":["includeRawData","archiveDataAfterExtract:10"]}
     * res: {"status":"success","data":{"api_key":"1fe04e8814d84337cb7269aa126833fb","description":"Auto archive","service_id":"62467636340a771c11c6607f","scopes":["includeRawData","archiveDataAfterExtract:10"],"active":true,"version":2,"name":"1fe...3fb","_id":"6360f60fa73c417917267a92","createdAt":"2022-11-01T10:33:51.469Z","updatedAt":"2022-11-01T10:33:51.469Z","__v":0}}
     *
     */
    async createAPIKey(serviceId, payload) {
        const res = await this._httpClient.post(API.APIKeyREST(serviceId), payload, { baseURL: this._baseURL });
        const resBody = lodash_1.default.get(res, 'data.data', {});
        return {
            result: resBody._id,
            entities: {
                apiKeys: { [resBody._id]: resBody },
            },
        };
    }
    /**
     * https://qa-console.blockpass.org/blockpass_console/v1/services/62467636340a771c11c6607f/apiKeys/6360f60fa73c417917267a92
     * method: PUT
     * payload: {"scopes":["includeRawData","textDataOnly","archiveDataAfterExtract:10"],"active":false,"description":"Auto archive"}
     * res: {"status":"success","data":{"_id":"6360f60fa73c417917267a92","api_key":"9d8765810561870339c620f78c2e87f2a02bd482f721ed844e4f0037d580e382","description":"Auto archive","service_id":"62467636340a771c11c6607f","scopes":["includeRawData","textDataOnly","archiveDataAfterExtract:10"],"active":false,"version":2,"name":"1fe...3fb","createdAt":"2022-11-01T10:33:51.469Z","updatedAt":"2022-11-01T10:36:28.340Z","__v":0}}
     */
    async updateAPIKey(serviceId, apiKeyId, payload) {
        const res = await this._httpClient.put(`${API.APIKeyREST(serviceId)}/${apiKeyId}`, payload, { baseURL: this._baseURL });
        const resBody = lodash_1.default.get(res, 'data.data', {});
        return {
            result: resBody._id,
            entities: {
                apiKeys: { [resBody._id]: resBody },
            },
        };
    }
    /**
     * https://qa-console.blockpass.org/blockpass_console/v1/services/62467636340a771c11c6607f/apiKeys/6360f60fa73c417917267a92
     * method: DELETE
     * res: {"status":"success","data":{}}
     */
    async deleteAPIKey(serviceId, apiKeyId) {
        const url = `${API.APIKeyREST(serviceId)}/${apiKeyId}`;
        await this._httpClient.delete(url, { baseURL: this._baseURL });
        return {
            result: null,
            entities: {},
        };
    }
}
exports.default = APIKey;
